import Vue from 'vue'
import AscErrorTypeIconLabel from '@/components/atoms/AscErrorTypeIconLabel'

export default Vue.extend({
  components: {
    AscErrorTypeIconLabel,
  },
  data: function () {
    return {}
  },

  computed: {
    getErrorType() {
      return this.params.data.errorType
    },
  },

  template: `<asc-error-type-icon-label 
  :error-type="getErrorType"/>`,
})
